import domus, { HgSupportedLanguage } from '@smg-real-estate/domus';
import { type VueHeadClient, VueHeadMixin } from '@unhead/vue';
import { createHead } from '@unhead/vue/client';
import { type App, type Component, createSSRApp } from 'vue';
import { type I18n } from 'vue-i18n';
import { type Router } from 'vue-router';

import { createI18n } from '@/i18n/setup/i18nSetup';
import { createRouter, initGuards } from '@/router';
import { createPinia } from 'pinia';

export function createApp(appComponent: Component): {
  app: App<Element>;
  router: Router;
  pinia: ReturnType<typeof createPinia>;
  head: VueHeadClient;
  i18n: I18n;
} {
  const router = createRouter();
  const head = createHead();
  const i18n = createI18n();
  initGuards(router, i18n);

  const app = createSSRApp(appComponent);
  const pinia = createPinia();
  app.use(head);
  app.mixin(VueHeadMixin);
  app.use(i18n);
  app.use(router);
  app.use(pinia);
  // needs to be last as domus sets the locale when all translations are loaded
  app.use(domus, {
    theme: import.meta.env.VUE_APP_PLATFORM,
    i18n: { instance: i18n, languages: { name: 'all', mode: 'lazy' } },
    router: { instance: router, defaultLanguage: HgSupportedLanguage.DE },
  });
  return { app, router, pinia, head, i18n: i18n };
}
